import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FilePlus2, SlidersHorizontal } from "lucide-react";
import { usePageSetup } from "../hooks/usePageSetup";
import { useShortcuts } from "../hooks/useShortcuts";
import { PageHeader } from "../components/PageHeader";
import { Button } from "../components/Button";
import { CustomizationsTable } from "../components/actuarial/CustomizationsTable";

/**
 * Landing screen for the catalog: what has already been customized, with two
 * ways in: create something new, or modify a guideline rating's debits.
 */
export function CustomizeConditionsPage() {
  usePageSetup("Customize Conditions", null);
  const navigate = useNavigate();
  const goNew = useCallback(() => navigate("/uw/actuarial/conditions/new"), [navigate]);
  const shortcuts = useMemo(() => ({ add: goNew }), [goNew]);
  useShortcuts(shortcuts);

  return (
    <>
      <PageHeader
        title="Customize Conditions"
        subtitle="Custom conditions, custom ratings, and debit modifications already in the catalog. Click one to edit it, or start a new customization."
        actions={
          <>
            <Button variant="secondary" icon={SlidersHorizontal} onClick={() => navigate("/uw/actuarial/conditions/modify")}>
              Modify Existing Condition
            </Button>
            <Button icon={FilePlus2} onClick={goNew}>
              New Custom Condition
            </Button>
          </>
        }
      />
      <CustomizationsTable />
    </>
  );
}
